import { useState, useEffect } from 'react'

function getFontSize(width: number): number {
  if (width < 768) return 13
  if (width < 1280) return 16
  return 20
}

/**
 * Returns a reactive font size that tracks the window width.
 * Drives responsive label sizing across all chart axes and legends.
 */
export function useDynamicFontSize(): number {
  const [fontSize, setFontSize] = useState(() => getFontSize(window.innerWidth))

  useEffect(() => {
    const handleResize = () => setFontSize(getFontSize(window.innerWidth))
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return fontSize
}
